type Platform = "ios" | "android" | "desktop"

export default function detectPlatform(): Platform {
  const ua = navigator.userAgent
  if (/iPad|iPhone|iPod/.test(ua)) return "ios"
  // iPadOS 13+ Safari reports a Macintosh UA by default; distinguish from real
  // Macs via touch support (Macs report maxTouchPoints === 0).
  if (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1) return "ios"
  if (/Android/.test(ua)) return "android"
  return "desktop"
}
